import { getIsBrowser } from '../_app/components/TrackingLog'

const expKey = 'f2Upsell'

export function dismissTrialIntro(flag: string): void {
  if (!getIsBrowser()) {
    return
  }
  window.localStorage.setItem(expKey, JSON.stringify({ ...getF2UpsellConfig(), [flag]: true }))
}

export function getF2UpsellConfig(): Record<string, boolean> {
  if (!getIsBrowser()) {
    return {}
  }
  return window.localStorage.getItem(expKey) ? JSON.parse(window.localStorage.getItem(expKey)!) : {}
}

export const useF2UpsellFeatureConfig = (
  flag: string
): { isDisabled: boolean; onClose: () => void } => {
  const f2UpsellConfig = getF2UpsellConfig()
  const isDisabled = Boolean(f2UpsellConfig[flag])
  const onClose = (): void => {
    dismissTrialIntro(flag)
  }
  return { isDisabled: isDisabled, onClose }
}
